import type { ReactNode } from 'react';

/** Calm inline message. `error` is announced immediately; `info` politely. */
export function Alert({ kind = 'info', children, action }: { kind?: 'info' | 'error' | 'success'; children: ReactNode; action?: ReactNode }) {
  const tone = kind === 'error' ? 'border-bad text-fg' : 'border-fg text-fg';
  return (
    <div role={kind === 'error' ? 'alert' : 'status'} className={`border-l-2 ${tone} py-1 pl-4 text-[15px] leading-relaxed`}>
      <div>{children}</div>
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
